@for (versjon of versjoner(); track versjon.id) {
  <dokument-kortvisning [dokumentversjon]="versjon"
                        signeringDeaktivert="true"
                        visSkjermingDeaktivert="true"
                        visNymerkingDeaktivert="true"
                        visAapneInline="false"
                        [bredde]="dokumentBredde()"
                        [hoeyde]="dokumentHoeyde()"/>
}
